<template>
  <div class="site-section dark live-trainings-wrapper">
    <div class="container">
      <div class="row main">
        <div class="col-8 col">
          <LiveTrainingsForm />
        </div>
        <div class="col-4 col training">
          <div>
            <h2 class="h4">
              Get the Training You Need in 3 Easy Steps
            </h2>
            <div class="row steps">
              <div class="col-12 col body-2">
                Choose a training for your team and fill the request form.
              </div>
              <div class="col-12 col body-2">
                Our sales team will contact you with the details.
              </div>
              <div class="col-12 col body-2">
                Enjoy top tier training with your teammates.
              </div>
            </div>
            <hr v-if="$store.state.layout === 'mobile'">
            <div class="row">
              <div class="col col-12">
                <p class="subtitle">
                  Trusted by companies like:
                </p>
              </div>
              <div class="col col-4 sm-4 logo">
                <LogoOracle class="logo-oracle" />
              </div>
              <div class="col col-4 sm-4 logo">
                <LogoAmazon class="logo-amazon" />
              </div>
              <div class="col col-4 sm-4 logo">
                <LogoWalmart class="logo-walmart" />
              </div>
              <div class="col col-4 sm-4 logo">
                <LogoAzercell class="logo-azercell" />
              </div>
              <div class="col col-4 sm-4 logo">
                <LogoVisa class="logo-visa" />
              </div>
              <div class="col col-4 sm-4 logo">
                <LogoJTI class="logo-jti" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import LiveTrainingsForm from '../../components/LiveTrainingsForm';
import LogoOracle from '../../assets/svg/logos/oracle.svg?vue-component';
import LogoAmazon from '../../assets/svg/logos/amazon.svg?vue-component';
import LogoWalmart from '../../assets/svg/logos/walmart.svg?vue-component';
import LogoVisa from '../../assets/svg/logos/visa.svg?vue-component';
import LogoAzercell from '../../assets/svg/logos/azercell.svg?vue-component';
import LogoJTI from '../../assets/svg/logos/jti.svg?vue-component';

export default {
  components: {
    LiveTrainingsForm,
    LogoOracle,
    LogoAmazon,
    LogoWalmart,
    LogoVisa,
    LogoAzercell,
    LogoJTI,
  },
  mixins: [global],
  // middleware({ redirect }) {
  //   redirect('/');
  // },
  async asyncData({
    $axios, route, $config, error,
  }) {
    const page = await $axios.$get(`/pages/${encodeURIComponent(route.path.replace(/^\/|\/$/g, ''))}`).catch(() => false);
    if (!page || $config.platform === 'fa') {
      return error({ statusCode: 404, message: 'Page not found' });
    }

    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();
    return {
      page,
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
};

</script>

<style lang="scss" scoped>
.live-trainings-wrapper {
  min-height: 100vh;
  background-color: var(--main-dark-light-1);

  .row.main {
    .h4 {
      margin-bottom: var(--spacing-36);
    }

    .subtitle {
      margin: 0 0 var(--spacing-20);
      font-size: 16px;
      color: var(--main-light-shade-4);
    }

    .training {
      align-items: center;
      justify-content: center;
      display: flex;
      margin: auto;

      .steps {
        margin-bottom: var(--spacing-120);
        counter-reset: section;

        .body-2 {
          padding-left: 67px;

          &:not(:last-of-type) {
            margin-bottom: 72px;
          }

          &:before {
            background-color: var(--accent-shade-2);
            border-radius: 50%;
            color: var(--main-light);
            font-size: 18px;
            font-weight: 600;
            line-height: 30px;
            text-align: center;
            counter-increment: section;
            content: counter(section);
            height: 28px;
            position: absolute;
            width: 28px;
            left: 15px;
            top: 0;
            z-index: 1;
          }

          &:after {
            background-color: var(--main-dark-shade-2);
            content: '';
            height: 100%;
            left: 28.25px;
            position: absolute;
            top: 38px;
            width: 1.5px;
          }

          &:last-of-type:after {
            width: 0;
          }
        }
      }

      .logo {
        margin-bottom: var(--spacing-20);

        svg path[fill] {
          fill: var(--main-dark-light-4);
        }
      }

      .logo-oracle,
      .logo-amazon,
      .logo-walmart,
      .logo-visa,
      .logo-azercell,
      .logo-jti {
        width: 92px;
      }
    }
  }
}

@include bp($bp-laptop) {
  .live-trainings-wrapper .row.main .training {
    .logo-oracle,
    .logo-amazon,
    .logo-walmart,
    .logo-visa,
    .logo-azercell,
    .logo-jti {
      width: 77px;
    }
  }
}

@include bp($bp-mobile) {
  .live-trainings-wrapper {
    background-color: var(--main-dark);

    .row.main {
      margin-left: -24px;
      margin-right: -24px;

      .h4 {
        font-size: 24px;
      }

      .subtitle {
        text-align: center;
        margin-bottom: var(--spacing-40);
        padding-top: var(--spacing-40);
      }

      hr {
        border: 1px solid rgba(255, 255, 255, 0.12);
      }

      .col-8 {
        padding: 0;
      }

      .training {
        padding: var(--spacing-80) var(--spacing-24) 0 var(--spacing-24);

        .steps {
          margin-bottom: var(--spacing-80);
        }
      }
    }
  }
}

@include bp($bp-phone) {
  .live-trainings-wrapper {
    .row.main {
      .training {
        .logo {
          display: flex;
          align-content: center;
          justify-content: center;
          height: 37px;
          margin-bottom: var(--spacing-40);
        }

        .logo:nth-of-type(3) {
          order: 2;
        }

        .logo:nth-of-type(5) {
          order: 1;
        }

        .logo:nth-of-type(7) {
          display: none;
        }
      }
    }
  }
}
</style>
